import { useParams } from 'react-router-dom';
import { useDocumentTitle } from '../lib/useDocumentTitle';
import { AppCta } from '../components/AppCta';
import { profileAppLink } from '../lib/appLinks';

/**
 * Public profile landing — `/u/:userId`. PB hook share_profile_html.pb.js
 * supplies the crawler OG tags; this component is the human-facing SPA view.
 *
 * Profile data isn't fetched here yet — public_profile.pb.js requires auth,
 * and we don't want to introduce an unauth endpoint just for this. The OG
 * card already shows the meaningful preview to messaging apps; humans hit
 * "Open in Skiffs" to see the full profile inside the app.
 */
export function ProfileShare() {
  const { userId } = useParams<{ userId: string }>();
  useDocumentTitle('Skiffs profile');

  const deepLink = profileAppLink(userId);

  return (
    <article className="skf-card">
      <h1 className="skf-title">View this profile in Skiffs.</h1>
      <p className="skf-subtitle">
        Skiffs profiles aren&rsquo;t public on the web — open the app to see the full profile,
        shared skiffs, and crew score.
      </p>
      <AppCta deepLink={deepLink} />
    </article>
  );
}
